<div class="checkin__process__info__box__wrapper">
  <div class="checkin__process__info__box__title">
    <i class="avc-icon-alert"></i>
    <span>
      {{ 'process-info-box-title' | translate }}
    </span>
  </div>
  <span
  class="checkin__process__info__box__description"
  [innerHTML]="'process-info-box-description' | translate | safeHtml"
  *ngIf="!isMobile">
  </span>
</div>
